/// <reference path="dialog.d.ts" />

import * as React from 'react';
import * as ReactDom from 'react-dom';
import { inject, injectable } from "inversify";
import autobind from "autobind-decorator";
import { Modal, Radio, Button } from 'antd';

/**
 * Dialog Service
 * Allow to show a Dialog Window
 */
@injectable()
export class DialogService {
	// Container
    private dialogBoxContainer: HTMLElement;
	// Div Id in index.html
    private baseNodeId: string = "message-boxes";
    /**
     * Constructor
     */
    constructor() {
        // Nothing
    }

	/**
	 * Method to show a Yes/No Dialog
	 * @param title
	 * @param message
	 * @param children
	 */
    @autobind
    public showYesNo(title: string, message: string = "", children: any = null): Promise<boolean> {
        return this.show(title, message, children, "Yes", true, "No");
    }
	/**
	 * Show Dialog
	 * @param title
	 * @param message
	 * @param children
	 * @param positiveButtonText
	 * @param negativeButton
	 * @param negativeButtonText
	 */
    @autobind
    public show(title: string, message: string = "", children: any = null, positiveButtonText: string = "Accept", negativeButton: boolean = false, negativeButtonText = "Cancel"): Promise<boolean> {
        if (this.dialogBoxContainer) {
            this.removeContainer();
        } else {
            var node = document.createElement("DIV");       
            document.getElementById(this.baseNodeId).appendChild(node);
            this.dialogBoxContainer = node;
        }

        return new Promise<boolean>((resolve, reject) => {
            var dialogBox = ReactDom.render(<DialogBoxView resolve={resolve} title={title} message={message} positiveButtonText={positiveButtonText} negativeButton={negativeButton} negativeButtonText={negativeButtonText} children={children} show={true} onUnmount={this.removeContainer} />, this.dialogBoxContainer) as any;
            dialogBox.openDialog();
        });
    }
	/**
	 * Remove Container
	 */
    @autobind
    private removeContainer() {
        ReactDom.unmountComponentAtNode(this.dialogBoxContainer);
        document.getElementById(this.baseNodeId).removeChild(this.dialogBoxContainer);
        this.dialogBoxContainer = null;
    }
}
/**
 * DialogBoxView
 */
export class DialogBoxView extends React.Component<DialogBoxViewProps, any> {
	/**
	 * Construtor
	 * @param props
	 */
    constructor(props) {
        super(props);
        this.state = {
            visible: true
        }
    }
	/**
	 * Open Dialog
	 */
    @autobind
    public openDialog() {
        this.setState({ visible: true });
    }
	/**
	 * Close Dialog
	 * @param result
	 */
    @autobind
    public closeDialog(result: boolean) {
        this.setState({ visible: false });
        this.props.resolve(result);
        this.props.onUnmount();
    }
	/**
	 * Render
	 */
    render() {
		// Footer Buttons
        let footerButtons = [];
		// Push ok button
        footerButtons.push(<Button key="Ok" size="small" onClick={() => this.closeDialog(true)}>{this.props.positiveButtonText || "Accept"}</Button>);
		// Push Cancel button
        if (this.props.negativeButton) {
            footerButtons.push(<Button key="Cancel" type="primary" size="small" onClick={() => this.closeDialog(false)}>{this.props.negativeButtonText || 'Cancel'}</Button>);
        }
        return (
            <Modal
                title={this.props.title}
                wrapClassName="vertical-center-modal"
                visible={this.state.visible}
                maskClosable={false}
                onOk={() => this.closeDialog(true)}
                onCancel={() => this.closeDialog(false)}
                footer={footerButtons}
            >
                <p>{this.props.message}</p>
                {this.props.children}
            </Modal >);
    }
}



// WEBPACK FOOTER //
// ./src/core/services/ui/dialog.service.tsx